var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.03752 7.60403L8.73389 7.90594C8.73389 7.90594 8.01217 8.62356 6.04216 6.66474C4.07216 4.70593 4.79388 3.9883 4.79388 3.9883L4.98509 3.79817C5.45613 3.32981 5.50054 2.57786 5.08958 2.02891L4.24892 0.905972C3.74027 0.22653 2.75739 0.136775 2.17438 0.716471L1.12798 1.75693C0.838901 2.04437 0.645183 2.41698 0.668673 2.83032C0.728771 3.8878 1.20722 6.16302 3.87699 8.81763C6.70818 11.6327 9.36464 11.7446 10.4509 11.6433C10.7945 11.6113 11.0934 11.4363 11.3342 11.1969L12.2812 10.2552C12.9205 9.6196 12.7402 8.52987 11.9223 8.08524L10.6486 7.39286C10.1116 7.10091 9.45726 7.18667 9.03752 7.60403Z",
    fill: "#2A3040"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.286832f0a8eaf7f4622fb639a344d670.svg";
export { ForwardRef as ReactComponent };